import React from 'react';
import PropTypes from 'prop-types';

import {WrapperStrip, Wrapper, Content, Left, Right} from './PicText.style';
import {CommonSubTitle, CommonTitle, CommonBody, StripOverlay} from './LightHomePage.style';
import Images from './Images';

export const PicText = props => {
  const {block, firstColor, secondColor} = props;
  const renderStripTitle = block.title && <CommonTitle>{block.title}</CommonTitle>;
  const renderStripSubTitle = block.subtitle && <CommonSubTitle>{block.subtitle}</CommonSubTitle>;
  const renderStripContent = block.body && <CommonBody>{block.body}</CommonBody>;
  const firstPic = block.pictures && block.pictures && block.pictures[0] && block.pictures[0].url;
  if (!block.backgroundStrip) {
    const renderLeft = firstPic && (
      <Left>
        <Images images={block.pictures} />
      </Left>
    );
    return (
      <Wrapper
        name={block.navigationTitle}
        id={block.navigationTitle}
      >
        {renderStripTitle}
        {renderStripSubTitle}
        <Content>
          {renderLeft}
          <Right
            expand={!firstPic}
            alignLeft={true}
          >
            {renderStripContent}
          </Right>
        </Content>
      </Wrapper>
    );
  }
  return (
    <div className="backgroundImage">
      <WrapperStrip
        url={firstPic}
        name={block.navigationTitle}
        id={block.navigationTitle}
      >
        <StripOverlay
          firstColor={firstColor}
          secondColor={secondColor}
        >
          {renderStripTitle}
          {renderStripSubTitle}
          {renderStripContent}
        </StripOverlay>
      </WrapperStrip>
    </div>
  );
};

PicText.propTypes = {
  block: PropTypes.object.isRequired,
  firstColor: PropTypes.string,
  secondColor: PropTypes.string
};



// WEBPACK FOOTER //
// ./containers/LightHomePage/PicText.js